var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cancellation-policy" }, [
    _c("div", { staticClass: "title mb-3" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.voMsg("tpl.cancellation.title")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "tick-li" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.bestPrice")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          _vm._s(_vm.voMsg("tpl.cancellation.bestPriceWeb")) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.service")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          _vm._s(_vm.voMsg("tpl.cancellation.emailService")) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("span", { staticClass: "li-title" }, [
          _vm._v(_vm._s(_vm.voMsg("tpl.cancellation.guestApp")))
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          _vm._s(_vm.voMsg("tpl.cancellation.guestAppInfo")) + "\n        "
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [
        _vm._v("Stornierungsbedingungen:")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "second-ul" }, [
        _c("li", [_vm._v("Bis 29 Tage vor Anreise: 0 %")]),
        _vm._v(" "),
        _c("li", [_vm._v("28–14 Tage vor Anreise: 50 %")]),
        _vm._v(" "),
        _c("li", [_vm._v("13–0 Tage vor Anreise: 100 %")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "li-title" }, [_vm._v("Zahlungsbedingungen:")]),
      _vm._v(" "),
      _c("ul", { staticClass: "second-ul" }, [
        _c("li", [_vm._v("20 % Anzahlung bei Buchung")]),
        _vm._v(" "),
        _c("li", [_vm._v("Restliche 80 % 14 Tage vor Anreise")]),
        _vm._v(" "),
        _c("li", [_vm._v("Überweisung")]),
        _vm._v(" "),
        _c("li", [_vm._v("Kreditkarte")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }